var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 8C10.2091 8 12 6.20914 12 4C12 1.79086 10.2091 0 8 0C5.79086 0 4 1.79086 4 4C4 6.20914 5.79086 8 8 8Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.67 9.02C8.45 9.01 8.23 9 8 9C5.58 9 3.32 9.67 1.39 10.82C0.51 11.34 0 12.32 0 13.35V16H9.26C8.47 14.87 8 13.49 8 12C8 10.93 8.25 9.93 8.67 9.02Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 12C18.75 11.78 18.72 11.58 18.69 11.37L19.83 10.36L18.83 8.63L17.38 9.12C17.06 8.85 16.7 8.64 16.3 8.49L16 7H14L13.7 8.49C13.3 8.64 12.94 8.85 12.62 9.12L11.17 8.63L10.17 10.36L11.31 11.37C11.28 11.58 11.25 11.78 11.25 12C11.25 12.22 11.28 12.42 11.31 12.63L10.17 13.64L11.17 15.37L12.62 14.88C12.94 15.15 13.3 15.36 13.7 15.51L14 17H16L16.3 15.51C16.7 15.36 17.06 15.15 17.38 14.88L18.83 15.37L19.83 13.64L18.69 12.63C18.72 12.42 18.75 12.22 18.75 12ZM15 14C13.9 14 13 13.1 13 12C13 10.9 13.9 10 15 10C16.1 10 17 10.9 17 12C17 13.1 16.1 14 15 14Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoles);
export default __webpack_public_path__ + "static/media/roles.bcc2dd7089097d32080172e6a0bb7263.svg";
export { ForwardRef as ReactComponent };